import LcChopCivicLiker from "./LcChopCivicLiker";

export { LcChopCivicLiker };
export default LcChopCivicLiker;
